module.exports = __webpack_public_path__ + "img/DV.94afeed1.png";